import { useSessionStore, type LoadingMessage } from '@gui/store/session/uiSessionStore';

export const DESIGN_SCHEME_LOADING_APPEARANCE_TIME_MS = 500;

export class DelayedDesignSchemeLoadingOverlay {
    private timerId: number | null = null;
    private visibleMessage: LoadingMessage | null = null;
    private messageId: string | null = null;

    public begin(message: LoadingMessage): void {
        this.end();

        const loadingMessageId = typeof crypto?.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
        this.messageId = loadingMessageId;

        this.timerId = window.setTimeout(() => {
            this.timerId = null;
            const nextMessage = { ...message, loadingMessageId };
            this.visibleMessage = nextMessage;
            useSessionStore.getState().setLoadingMessage(nextMessage);
        }, DESIGN_SCHEME_LOADING_APPEARANCE_TIME_MS);
    }

    public end(): void {
        if (this.timerId != null) {
            window.clearTimeout(this.timerId);
            this.timerId = null;
        }

        if (!this.visibleMessage) return;

        const currentMessage = useSessionStore.getState().loadingMessage;
        if (currentMessage?.loadingMessageId === this.messageId) {
            useSessionStore.getState().setLoadingMessage(null);
        }

        this.visibleMessage = null;
        this.messageId = null;
    }
}
